import React, { useEffect } from "react";
import axios from "axios";
import { postUserVisit } from "./isFreeLimit";
import { getPaywallLimit } from "./getPaywallArticleLmt";
export function postVisitData(story) {
  async function postUserVisitData() {
    const uri = "/extlog/user-visit";
    const urlLocation = decodeURI(window.location.pathname);
    await axios.post(uri, {
      uri: urlLocation,
      accesslevel: story.access !== "undefined" && (story.access ? story.access : "login"),
    })
      .then(res => console.log("response", res))
      .catch(e => console.log(e));
  }
  async function makeUserCountsCall(articlesLimit) {
    await fetch("/tulo/isLoggedIn")
      .then(function (res) {
        return res.json();
      }).then(function (data) {
        if (!data.isLoggedIn) {
          return;
        } else {
          const visitCounts = parseInt(data.count ? (data.count) : 0);
          const urlLocation = decodeURI(window.location.pathname);
          const visitedArticleSlug = data["visited_uris"];
          const isVisitedSlug = visitedArticleSlug && visitedArticleSlug.includes(urlLocation) || false;
          const userCheck = data.isLoggedIn;
          const activeProducts = (data["active_products"] && data["active_products"].item["active_products"]) || [];
          const isIlkkaDigi = activeProducts.includes("ilkka_digi");
          const isILDigi = activeProducts.includes("il_digi");
          const isIPDigi = activeProducts.includes("ip_digi");
          const isMiniDigi = activeProducts.includes("ip_digimini");
          const activeProductCheck = (isIlkkaDigi || isILDigi || isIPDigi || isMiniDigi);
          if (postUserVisit(userCheck, activeProductCheck, visitCounts, articlesLimit, isVisitedSlug)) {
            postUserVisitData();
          }
        }
      })
  }
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    } else {
      const paywallArticlesLimit = getPaywallLimit();
      if (story.access !== "undefined" && story.access !== "public") {
        makeUserCountsCall(paywallArticlesLimit);
      }
      else {
        console.log("logged no matter as story is PUBLIC, articlelimit does not matter, no postUserVisitData call")
      }
    }
  }, [])
}
